<template>
	<div id="experiences_section" class="section">
		<div class="flex_container centered_horizontally" >
			<div class="section_content">
				<header class="section_title_container">
					<span class="section_title">Experiences</span>
				</header>
				<div class="section_subtitle_container">
					<span class="section_subtitle">Expertise</span>
				</div>
				<section class="expertise_list">
					<div v-for="experience in experiences" :key="experience.title" class="expertise">
						<h2>{{experience.title}}</h2>
						<p v-for="example in experience.examples" :key="example">
							{{example}}
						</p>
					</div>
				</section>
				<div class="section_subtitle_container">
					<span class="section_subtitle">Internships</span>
				</div>
				<section>
					<div class="company_list_container">
						<ul class="company_list">
							<li v-for="internship in internships" :key="internship.url"
								:style="{
									backgroundImage: internship.backgroundImage,
									backgroundColor: internship.backgroundColor
								}"
							>
								<a :href=internship.url>
									<div>
										<img :src=internship.img alt="">
									</div>
								</a>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "LandingPageExperiencesSection",
		data () {
			return {
				experiences: [
					{
						title: "Web Development",
						examples: [
							"Internships in Full-Stack Development",
							"Node.js, Ruby on Rails, Python and PHP",
							"Dev-Ops",
						]
					},
					{
						title: "Mobile Development",
						examples: [
							"Android Apps With Java and Socket.io",
							"Cross Platform Application With React Native",
						]
					},
					{
						title: "Native Development",
						examples: [
							"Implemented OS features in NachOS",
							"Projects in 6502 Micro-Processor and Spark assembly",
							"OpenGL Applications",
						]
					},
				],
				internships: [
					{
						url: "https://www.boreal-is.com/fr/",
						img: "/static/images/borealis_md.png",
						backgroundImage: "url(/static/images/borealis_bg.jpg)",
						backgroundColor: "black",
					},
					{
						url: "https://www.rtings.com/",
						img: "/static/images/rtings_md.png",
						backgroundImage: "url(/static/images/rtings_bg.jpg)",
						backgroundColor: "black",
					},
					{
						url: "https://www.metareal.com/",
						img: "/static/images/metareal_md.png",
						backgroundImage: "url(/static/images/metareal_bg.jpg)",
						backgroundColor: "black",
					},
					{
						url: "https://www.mirego.com/",
						img: "/static/images/mirego_md.png",
						backgroundImage: "",
						backgroundColor: "black",
					},
				],
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/global.scss";
	@import "../../styles/text_mixins.scss";
	@import "../../styles/position_mixins.scss";
	@import "../../styles/spacing_mixins.scss";
	@import "../../styles/dimension_mixins.scss";
	@import "../../styles/transition_mixins.scss";
	@import "../../styles/background_mixins.scss";

	.flex_container {
		display: flex;
		&.centered_horizontally {
			justify-content: center;
		}
		&.centered_vertically {
			align-content: center;
		}
	}
	.grey_background {
		background-color: $dark_contrast;
	}
	.section {
		flex-direction: column;
		justify-content: center;
		color: black;
		background-color: $light_contrast;
		& .section_content {
			@include spacing( 40px 0, 0 );
			& .section_title_container {
				@include spacing( 10px 20px, 0 );
				display: flex;
				justify-content: center;
				& .section_title {
					@include spacing( 0px, 20px );
					@include text(
						$transform: uppercase,
						$font-family: "Barlow Condensed",
						$font-size: 3em,
						$font-weight: 800
					);
				}
			}
			& .section_subtitle_container {
				display: flex;
				@include spacing( 20px, 0 );
				& .section_subtitle {
					@include spacing( 0, 20px );
					@include text(
						$transform: uppercase,
						$font-family: "Barlow Condensed",
						$font-size: 2.0em,
						$font-weight: 400
					);
				}
				border-bottom: 1px solid black;
			}
		}
	}
	.expertise_list {
		display: flex;
		flex-flow: row wrap;
		@include spacing( 0px, 0px );
		& .expertise {
			flex: 1;
			@include min-dimensions( 25%, 150px );
			@include spacing( 10px 20px, 0px );
			& p {
				color: $grey_text;
			}
		}
	}
	.company_list_container {
		& ul.company_list {
			display: flex;
			flex-flow: row wrap;
			list-style: none;
			@include background(
				$box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3)
			);
			@include spacing( 0px, 0px );
			& li {
				flex: 1;
				background-size: 175% auto;
				@include transition( all 0.2s ease );
				@include min-dimensions( $height: 250px, $width: 300px );
				@include background(
					$box-shadow: 5px 5px 20px $less_transparent_black,
					$color: $less_transparent_black
				);

				& a {
					outline: 0;
				}
				&:hover {
					z-index: 99;
				}

				& div {
					display: flex;
					height: 100%;
					background-color: $less_transparent_black;
					@include spacing( 0px, 0px 25px 0px 25px );
					@include content_position( center, center );
					@include transition( all 0.2s ease );
					&:hover {
						@include background(
							$box-shadow: 5px 5px 20px $less_transparent_black,
							$color: $less_transparent_black
						);
						@include transition( all 0.2s ease );
					}
				}

				& img {
					image-rendering: auto;
					transition: max-width 0.2s linear;
					max-width: 200px;
				}
			}
		}
	}

	@media (max-width: 481px) {
		.expertise_list {
			& .expertise {
				//@include min-dimensions( 100%, 150px );
				flex-basis: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/landingPage/experiencesSection.vue